import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl10ValidationSchema = () => {
  yup.setLocale({ string: {} });
  const { t } = useTranslation();
  const minDate = new Date("1900-01-01");
  return yup
    .object()
    .shape({
      pastApp: yup
        .object()
        .shape({ m02_id: yup.string(), label: yup.string() })
        .nullable()
        .default(undefined)
        .transform((value, originalValue) => {
          if (
            originalValue &&
            typeof originalValue === "object" &&
            Object.keys(originalValue).length === 0
          ) {
            return undefined;
          }
          return value;
        }),
      d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .min(minDate, t("Η ημερομηνία πρέπει να είναι μετά την 01/01/1900")),
      fudocPrakt1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      d50_id2: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate2: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .min(minDate, t("Η ημερομηνία πρέπει να είναι μετά την 01/01/1900")),
      fudocPrakt2: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardService: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      endOfService: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό"))
        .min(minDate, t("Η ημερομηνία πρέπει να είναι μετά την 01/01/1900")),
      keimeno: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      oldBoardMembers: yup.array().of(
        yup.object().shape({
          fp1Afm: yup.string().when("ok", {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1Name: yup.string().when("fp1Afm", {
            is: (fp1Afm: string) => fp1Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1Surname: yup.string().when("fp1Afm", {
            is: (fp1Afm: string) => fp1Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1Fathersname: yup.string().when("fp1Afm", {
            is: (fp1Afm: string) => fp1Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1StartDate: yup
            .date()
            .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
            .when("fp1Afm", {
              is: (fp1Afm: string) => fp1Afm != null,
              then: (schema) =>
                schema.required(t("Το πεδίο είναι υποχρεωτικό")),
              otherwise: (schema) => schema.nullable(),
            }),
          fp1EndDate: yup
            .date()
            .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
            .when("fp1Afm", {
              is: (fp1Afm: string) => fp1Afm != null,
              then: (schema) =>
                schema.required(t("Το πεδίο είναι υποχρεωτικό")),
              otherwise: (schema) => schema.nullable(),
            }),
          fp1Idiot: yup.object().when("fp1Afm", {
            is: (fp1Afm: string) => fp1Afm != null,
            then: (schema) =>
              schema.required(t("Το πεδίο είναι υποχρεωτικό")).shape({
                value: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
                label: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
              }),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1SoloRepresentative: yup.number().when("fp1Afm", {
            is: (fp1Afm: string) => fp1Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1JointlyRepresentative: yup.number().when("fp1Afm", {
            is: (fp1Afm: string) => fp1Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2Afm: yup.string().when("ok", {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2Name: yup.string().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2Surname: yup.string().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2Fathersname: yup.string().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2Doy: yup.object().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
          }),

          fp2Adt: yup.string().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2Street: yup.string().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2Number: yup.string().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2City: yup.string().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2ZipCode: yup.string().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2Idiot: yup.object().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) =>
              schema.required(t("Το πεδίο είναι υποχρεωτικό")).shape({
                value: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
                label: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
              }),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2StartDate: yup.date().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2EndDate: yup.date().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2SoloRepresentative: yup.number().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2JointlyRepresentative: yup.number().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
        }),
      ),
    })
    .test(
      "check-board-members",
      t("Το ΔΣ πρέπει να αποτελείται από 1 μέλος ή από 3 έως 15 μέλη."),
      function (value) {
        const members = value?.oldBoardMembers || [];

        if (
          members.length === 0 ||
          members.length === 2 ||
          members.length > 15
        ) {
          return this.createError({
            message: t(
              "Το ΔΣ πρέπει να αποτελείται από 1 μέλος ή από 3 έως 15 μέλη.",
            ),
          });
        }

        let allFieldsFilled = true;

        members.forEach((member: Record<string, any>, index) => {
          Object.keys(member).forEach((key) => {
            if (
              member[key] == null ||
              member[key] === "" ||
              (key === "fp2Doy" && Object.keys(member[key]).length === 0)
            ) {
              allFieldsFilled = false;
            }
          });
        });

        return allFieldsFilled
          ? true
          : this.createError({
              message: t("Υπάρχει μη συμπληρωμένο πεδίο στα μέλη."),
            });
      },
    )
    .test(
      "valid-board-member-dates",
      t("Ελέγξτε τις ημερομηνίες θητείας των μελών."),
      function (value) {
        const members = value?.oldBoardMembers || [];
        let invalidDate = false;

        members.forEach((member: Record<string, any>) => {
          const startDate = new Date(member.fp1StartDate);
          const endDate = new Date(member.fp1EndDate);
          if (startDate >= endDate) {
            invalidDate = true;
          }
        });

        return !invalidDate
          ? true
          : this.createError({
              message: t("Ελέγξτε τις ημερομηνίες θητείας των μελών."),
            });
      },
    );
};
